<template>
  <div
    ref="container"
    class="as-schematic"
    v-if="getGroup"
    :style="{ width: schematicWidth }"
  >
    <div ref="head" class="as-schematic__head">
      <span v-for="(round, indexRound) in getGroup.rounds" :key="indexRound">
        {{ round.name }}
      </span>
    </div>
    <div ref="body" class="as-schematic__body as-new">
      <div
        :style="{ maxHeight: getMaxHeightBracketRound + 'px' }"
        class="as-bracket-round"
        v-for="(rounds, _index) in mappingRounds"
        :key="rounds.id"
        :class="`as-bracket-round__as-${_index}`"
      >
        <div
          class="as-bracket-round__item"
          v-if="rounds?.match_up_chunks"
          v-for="(matches, _key) in rounds.match_up_chunks"
          :class="`as-bracket-round__item__as-bracket__${_index}-item__${_key}`"
          :key="_key"
        >
          <div class="as-bracket-round__item--team">
            <BracketItemMatch
              v-for="matchItem in matches"
              :match="matchItem"
              :matchID="match.id"
              :isShowTheChampion="getIsShowTheChampion(rounds)"
            />
          </div>
          <div class="as-bracket-round__item--connecter"></div>
          <div class="as-bracket-round__item--line"></div>
        </div>
      </div>
    </div>
  </div>
  <NoData v-else />
</template>
<script setup lang="ts">
import { defineProps, ref, computed, onMounted, nextTick } from "vue";
import type {
  IMatch,
  ITournamentJsonData,
  ITournamentRound,
} from "~src/interfaces/tennis";
import BracketItemMatch from "./BracketItemMatch.vue";
import {
  getMappingGroups,
  findGroupByMatchId,
} from "~src/helpers/tennis";
import NoData from "~src/components/NoData.vue";

interface IProps {
  tournament: ITournamentJsonData;
  match: IMatch;
  isHomePage: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isHomePage: false,
});

const rounds = computed<ITournamentRound[]>(() => {
  let rounds = props.tournament.rounds;
  rounds = rounds.sort(
    (a: ITournamentRound, b: ITournamentRound) => a.number - b.number
  );
  return rounds;
});

const isShow = computed<boolean>(() => {
  if (props.tournament.rounds) {
    return true;
  }

  return false;
});

const getIsShowTheChampion = (round: any) => {
  if (round?.abbr === "F" || (round?.name).toUpperCase() === "FINAL") {
    return true;
  }

  return false;
};
const getGroup = computed<any>(() => {
  const __rounds = props.tournament.rounds;
  const groups = props.tournament.groups;
  const match_ups = props.tournament.match_ups;
  const teams = props.tournament.teams;
  const matches = props.tournament.matches ?? [];

  if (groups && match_ups) {
    const _groups = getMappingGroups(groups, __rounds, match_ups, teams, matches);
    if (_groups) {
      const _group = findGroupByMatchId(_groups, props.match.id);
      const _mappingRounds = _group ? _group.rounds : null;
      if (_mappingRounds) {
        _mappingRounds.sort((a, b) => {
          const lengthA = a.match_ups ? a.match_ups.length : 0;
          const lengthB = b.match_ups ? b.match_ups.length : 0;
          return lengthB - lengthA;
        });

        return _group;
      }
    }
  }

  return null;
});

const mappingRounds = computed<any>(() => {
  const group = getGroup.value;
  const mappingRounds = group ? group.rounds : [];

  console.log("mappingRounds: ", mappingRounds);
  return mappingRounds;
});

const schematicWidth = computed(() => {
  return `${mappingRounds.value.length * 250}px`;
});

const schematicHeight = computed(() => {
  return bodySchematicHeight.value + 50;
});

const getMaxHeightBracketRound = computed(() => {
  const __rounds = mappingRounds.value ? mappingRounds.value : [];
  if (__rounds) {
    const _length = __rounds[0].match_ups.length;
    return _length * 87 + _length * 10;
  }

  return 500;
});

const bodySchematicHeight = computed(() => {
  let __height = 0;
  let __match_ups = mappingRounds.value
    ? mappingRounds.value[0].match_ups.length
    : 0;
  console.log("__match_ups: ", __match_ups);
  if (__match_ups) {
    __height = Math.floor(__match_ups) * 94;
  }

  return __height;
});

const head = ref(null);
const body = ref<HTMLDivElement | null>(null);
const container = ref<HTMLDivElement | null>(null);
// Function to scroll to the active item
const scrollToActiveItem = () => {
  const activeItem = body.value?.querySelector(
    ".as-schematic-item__body.as-active"
  );
  if (activeItem) {
    activeItem.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  } else {
    console.log("No round active");
  }
};

// Use onMounted lifecycle hook to scroll after component is mounted
onMounted(async () => {
  await nextTick();
  body.value = document.querySelector(".as-schematic__body");
  setTimeout(scrollToActiveItem, 100);
});
</script>

<script lang="ts">
export default {};
</script>
